import * as THREE from 'three';

/** Three.js-Szene: Hintergrund, Licht, Bodenraster, Achsenkreuz — der SketchUp-Look. */
export class SceneManager {
  scene = new THREE.Scene();
  renderer: THREE.WebGLRenderer;
  private vanGroup = new THREE.Group();

  /** Lage der Arbeitsfläche im Fenster (für fixed positionierte Overlays). */
  canvasRect(): DOMRect {
    return this.canvas.getBoundingClientRect();
  }

  constructor(private canvas: HTMLCanvasElement) {
    this.renderer = new THREE.WebGLRenderer({ canvas, antialias: true });
    this.renderer.setClearColor(0xdfe7ee);
    this.scene.background = new THREE.Color(0xdfe7ee);

    const ambient = new THREE.AmbientLight(0xffffff, 1.9);
    this.scene.add(ambient);
    const dir = new THREE.DirectionalLight(0xffffff, 1.4);
    dir.position.set(6, -4, 10);
    this.scene.add(dir);
    const dir2 = new THREE.DirectionalLight(0xffffff, 0.5);
    dir2.position.set(-5, 6, 3);
    this.scene.add(dir2);

    this.scene.add(this.buildGrid());
    this.scene.add(this.buildAxes());
    this.scene.add(this.vanGroup);
  }

  private buildGrid(): THREE.Group {
    const g = new THREE.Group();
    const minor = new THREE.LineBasicMaterial({ color: 0xc3ccd4 });
    const major = new THREE.LineBasicMaterial({ color: 0xa5b1bb });
    const half = 15;
    const ptsMinor: number[] = [];
    const ptsMajor: number[] = [];
    for (let i = -half; i <= half; i++) {
      const arr = i % 5 === 0 ? ptsMajor : ptsMinor;
      arr.push(i, -half, 0, i, half, 0);
      arr.push(-half, i, 0, half, i, 0);
    }
    g.add(makeLineSegments(ptsMinor, minor));
    g.add(makeLineSegments(ptsMajor, major));
    return g;
  }

  private buildAxes(): THREE.Group {
    const g = new THREE.Group();
    const red = new THREE.LineBasicMaterial({ color: 0xd23c3c });
    const green = new THREE.LineBasicMaterial({ color: 0x3c9e4a });
    const blue = new THREE.LineBasicMaterial({ color: 0x3c6fd2 });
    g.add(makeLineSegments([0, 0, 0, 6, 0, 0], red));
    g.add(makeLineSegments([0, 0, 0, 0, 6, 0], green));
    g.add(makeLineSegments([0, 0, 0, 0, 0, 3], blue));
    g.add(makeLineSegments([0, 0, 0, -1.5, 0, 0], red));
    g.add(makeLineSegments([0, 0, 0, 0, -1.5, 0], green));
    return g;
  }

  resize(): void {
    const w = this.canvas.clientWidth;
    const h = this.canvas.clientHeight;
    this.renderer.setSize(w, h, false);
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  }

  render(camera: THREE.PerspectiveCamera): void {
    this.renderer.render(this.scene, camera);
  }

  renderOnce(camera: THREE.PerspectiveCamera): void {
    this.render(camera);
  }
}

function makeLineSegments(coords: number[], material: THREE.LineBasicMaterial): THREE.LineSegments {
  const geo = new THREE.BufferGeometry();
  geo.setAttribute('position', new THREE.Float32BufferAttribute(coords, 3));
  return new THREE.LineSegments(geo, material);
}
